export default "__VITE_ASSET__DzJ5rREM__"